import { format } from 'date-fns';
import dayjs from 'dayjs';
export function formatTimeRange(start: string, end: string) {
    if (!start || !end) return '';

    const startDate = new Date(start);
    const endDate = new Date(end);

    // Nếu cùng tháng và cùng năm
    const dayStart = format(startDate, 'd');
    const dayEnd = format(endDate, 'd');
    const month = format(startDate, 'M');
    const year = format(startDate, 'yyyy');
    if (
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getFullYear() === endDate.getFullYear()
    ) {
        return `Ngày ${dayStart} - ${dayEnd} tháng ${month} năm ${year}`;
    } else {
        return `Ngày ${dayStart} tháng ${month} năm ${year} - Ngày ${dayEnd} tháng ${month} năm ${year}`;
    }
}

export function formatTime(time: string) {
    if (!time) return '';

    return dayjs(time).subtract(7, 'hour').format('HH:mm');
}

export const formatDate = (date: string) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
};

export function getWorkingDaysInMonth(year: number, month: number) {
    const daysInMonth = dayjs(`${year}-${month}-01`).daysInMonth();
    let workingDays = 0;

    for (let day = 1; day <= daysInMonth; day++) {
        const date = dayjs(`${year}-${month}-${day}`);
        const dayOfWeek = date.day(); // 0 = Sunday, 6 = Saturday

        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            workingDays++;
        }
    }

    return workingDays;
}
